export const COMPANY = {
  name: "PJ Caçambas de Entulho",
  phoneDisplay: "(11) 97439-4691",
  phoneTel: "+5511974394691",
  whatsappBase: "https://wa.me/5511974394691",
  email: "contato@pjcacambasdeentulho.com.br",
  city: "Jundiaí",
  region: "Jundiaí · SP",
};

export const waLink = (msg = "Olá! Gostaria de solicitar um orçamento de caçamba.") =>
  `${COMPANY.whatsappBase}?text=${encodeURIComponent(msg)}`;

export const telLink = `tel:${COMPANY.phoneTel}`;

export const NEIGHBORHOODS = [
  "Centro", "Vila Arens", "Anhangabaú", "Eloy Chaves", "Medeiros",
  "Engordadouro", "Ponte São João", "Jardim Bonfiglioli", "Vila Hortolândia",
  "Retiro", "Colônia", "Vila Rio Branco", "Jardim do Lago", "Agapeama",
  "Vila Progresso", "Jardim Tulipas", "Fazenda Grande", "Jardim Ermida",
  "Caxambu", "Gramadão", "Ivoturucaia", "Corrupira", "Jardim Martins",
  "Jardim Samambaia", "Jardim Guanabara", "Jardim Tarumã", "Vila Liberdade",
  "Vila Maringá", "Jardim São Camilo", "Vila Comercial",
];
